import type { Channel } from "@school-sales-ai/shared";

/**
 * What the CRM calls each channel a lead or a message is stored under. One table
 * so a new channel fails to compile everywhere it is named, instead of reading
 * "Web" by omission in the places a ternary forgot it (the state before Instagram).
 */
export const CHANNEL_LABEL: Record<Channel, string> = {
  web: "Web",
  whatsapp: "WhatsApp",
  instagram: "Instagram",
};

/** The compact form, for the Kanban card and the table. */
export const CHANNEL_SHORT: Record<Channel, string> = {
  web: "Web",
  whatsapp: "WA",
  instagram: "IG",
};

/** The status dot beside the channel name. */
export const CHANNEL_DOT: Record<Channel, string> = {
  web: "bg-ink-300",
  whatsapp: "bg-wa-green",
  instagram: "bg-pink-500",
};

/**
 * A chat the team can take over: the AI pause switch and the reply box apply.
 * The widget is not one — a web lead has nowhere to be answered from here.
 */
export function isMessagingChannel(channel: Channel): boolean {
  return channel !== "web";
}
